import { HostListener, Component, OnDestroy } from '@angular/core';
import { Router, NavigationEnd  } from '@angular/router';
import { StateService } from './services/state.service';
import { ApiService } from './services/api.service';
import { VehicleService } from './services/vehicle.service';
import { AuthService } from './services/auth.service';
import * as bootstrap from "bootstrap";
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
	title = 'oncore';
	isLoggedIn = false;
	pollInterval:any = false;
	showControl = true;
	supernames:any = [];
	vehiclePlate = "";
	resultNull = false;
	resultFound = false;
	tryCounter = 0;
	userObj:any = {};
	isSubmitting = false;

	loginSearchReachTrack = 0;
  
	currentRoute = '';
	constructor(private router: Router, private stateSvc: StateService, private apiSvc: ApiService, private vehicleSvc: VehicleService, private authSvc: AuthService) {
		// subscribe to URL address, track if any changes on URL
		this.router.events.subscribe((event:any) => {
			if (event instanceof NavigationEnd) {
				this.currentRoute = this.router.url;
			}
		});
		this.stateSvc.isLoggedIn.subscribe((result:boolean) => {
			this.userObj = this.stateSvc.getLocalSession();
			this.isLoggedIn = result;
			if(!this.isLoggedIn && this.userObj?.username){
				this.stateSvc.setIsLoggedIn(true);
			}
			
			if(this.isLoggedIn){
				setTimeout(() => {
					if(this.userObj.superuser){
						this.supernames = this.userObj.masterusernames;
						$('#masterAccount').show().addClass('in');
						$('#masterAccountBackdrop').show().addClass('in');
					}
				},1000);
				// if already logged in, fetch vehicles
				this.callVehicleApi();
				// create interval to fetch vehicles
				this.pollInterval = setInterval(() => {
					this.callVehicleApi();
				}, 35 * 1000);
			}
		});
		this.stateSvc.showControl
		.subscribe((result) => {
			this.showControl = result;
		});
		this.stateSvc.logoutTriggered
		.subscribe((result) => {
			this.logoutCtrl(result);
		});
	}
	
	/**
	 * if browser closed, turn off flag is_looged_in
	 */
	@HostListener('window:beforeunload', ['$event'])
	unloadHandler(event: Event) {
		//this.stateSvc.setIsLoggedIn(false);
	}
	
	/**
	 * navigate to which page
	 */
	navigatePage(page){
		this.apiSvc.navigateInternal(page);
	}
	
	/**
	 * logout function
	 * remove session stored in local browser
	 */
	logout() {
		let masterUser = sessionStorage.getItem('master-user');
		if(masterUser) {
			let tempPwd = this.authSvc.getDefaultLogin();
			let reversePwd = this.authSvc.reversHashBlowfish(tempPwd);
			this.authSvc.login(masterUser, reversePwd)
			.subscribe((user:any) => {
				sessionStorage.removeItem('master-user');
				if(localStorage.getItem('jump_direct')){
					localStorage.removeItem('jump_direct');
				}
				if(localStorage.getItem('markerShown')){
					localStorage.removeItem('markerShown');
				}
				// stote user local
				this.authSvc.storeUserLocally(user);
				window.location.reload(true);
			});
		} else {
			this.stateSvc.logout();
		}
	}
	
	logoutCtrl(val) {
		if(val){
			clearInterval(this.pollInterval);
			this.pollInterval = false;
			$('#masterAccountBackdrop').hide().removeClass('in');
			$('#masterAccount').hide().removeClass('in');
			this.stateSvc.setLogoutTriggered(false);
		}
	}
	
	loginWithId(username){
		this.isSubmitting = true;
		let tempPwd = this.authSvc.getDefaultLogin();
		let reversePwd = this.authSvc.reversHashBlowfish(tempPwd);
		this.authSvc.login(username, reversePwd)
		.subscribe((user:any) => {
			this.vehicleSvc.getVehicles(username).subscribe((vhc) => {
				// get user info from session
				let userString = sessionStorage.getItem('user');
				// parse into JSON format, local only store as single string
				let currentUser:any = JSON.parse(userString);
				sessionStorage.setItem('master-user',currentUser.username);
				// stote user local
				this.authSvc.storeUserLocally(user);
				this.apiSvc.navigateInternal('map');
				setTimeout(() => {
					window.location.reload(true);
				},700)
			},(err) => {
				// get user info from session
				let userString = sessionStorage.getItem('user');
				// parse into JSON format, local only store as single string
				let currentUser:any = JSON.parse(userString);
				if(this.loginSearchReachTrack == 0){
					sessionStorage.setItem('master-user',currentUser.username);
					this.loginSearchReachTrack++;
				}
				this.loginOut(username);
			});
		});
	}

	loginOut(username){
		this.authSvc.getCredentialData()
		.subscribe((str:any) => {
			this.authSvc.getOutUsers(username, str?.collection_keys?.master, str?.collection_keys?.base_url)
			.subscribe((user:any) => {
				if(user?.username){
					// get user info from session
					let userString = sessionStorage.getItem('user');
					// parse into JSON format, local only store as single string
					let currentUser:any = JSON.parse(userString);
					// sessionStorage.setItem('master-user',currentUser.username);
					// stote user local
					this.authSvc.storeUserLocally(user);

					this.vehicleSvc.getUsersVehicles()
					.subscribe((uvhcls:any) => {
						if(uvhcls?.length > 0){
							let dataUvhsc:any = [];
							uvhcls.forEach((uvhc:any) => {
								dataUvhsc.push(uvhc.terminalNo);
							})
							this.stateSvc.setUsersVehicleIds(dataUvhsc);
						}
						// set flag is_logged_in
						this.stateSvc.setIsLoggedIn(true);
						// redirect to map page
						this.apiSvc.navigateInternal('map');
						setTimeout(() => {
							window.location.reload(true);
						},700)
					});
				}
			},
			(err) => {
				// get user info from session
				let userString = sessionStorage.getItem('user');
				// parse into JSON format, local only store as single string
				let currentUser:any = JSON.parse(userString);
				if(this.loginSearchReachTrack == 0){
					sessionStorage.setItem('master-user',currentUser.username);
					this.loginSearchReachTrack++;
				}
				this.loginOutTrack(username);
			});
		})
	}

	loginOutTrack(username){
		this.authSvc.getAccessTokenTrack()
		.subscribe((result) => {
			if(result?.code == 0){
				let tokenInfo:any = result?.result;
				tokenInfo.token = result?.result?.accessToken;
				tokenInfo.token_expiry = this.authSvc.generateExpiryTracksoliToken(result?.result);
				localStorage.setItem('tracksolidtoken', JSON.stringify(tokenInfo));

				this.authSvc.getTrackSolidUsers(username)
				.subscribe((user) => {
					if(user?.username){
						// get user info from session
						let userString = sessionStorage.getItem('user');
						// parse into JSON format, local only store as single string
						let currentUser:any = JSON.parse(userString);
						// sessionStorage.setItem('master-user',currentUser.username);
						// stote user local
						this.authSvc.storeUserLocally(user);
						
						this.vehicleSvc.getUsersTracksolidVehicles()
						.subscribe((uvhcls:any) => {
							if(uvhcls?.length > 0){
								let dataUvhsc:any = [];
								let vehicleGroups:any = [];
								let objByhcl:any = {};
								uvhcls.forEach((uvhc:any) => {
									let imeiNo = uvhc.imei;
									dataUvhsc.push({imeiNo: uvhc});

									if (vehicleGroups.indexOf(uvhc.deviceGroup) == -1) {
										vehicleGroups.push(uvhc.deviceGroup);
									}

									objByhcl[uvhc.imei] = uvhc;
								});console.log('objByhcl',objByhcl)
								// this.stateSvc.setVehicleGroups(vehicleGroups);
								this.stateSvc.setUsersVehicleObjIds(objByhcl);
								this.stateSvc.setUsersVehicleIds(dataUvhsc);
							}
							// set flag is_logged_in
							this.stateSvc.setIsLoggedIn(true);
							// redirect to map page
							this.apiSvc.navigateInternal('map');
							setTimeout(() => {
								window.location.reload(true);
							},700)
						});
					}else{
						this.isSubmitting = false;
					}
				}, (err) => {
					console.log('err',err);
					this.isSubmitting = false;
				})
			}else{
				this.isSubmitting = false;
			}
			
		}, (err) => {
			console.log('err',err);
			this.isSubmitting = false;
		});
	}
	
	callVehicleApi(){
		let vhclCounts = 0;
		let toFetchOut = false;

		if(this.userObj.source == "oncore"){
			this.vehicleSvc.getVehicles().subscribe((vhc) => {
				// redirect to map page if current route is login page
				if(this.currentRoute == ''){
					this.apiSvc.navigateInternal('map');
				}
				vhclCounts = vhc.length;
				toFetchOut = vhclCounts == 0? true : false;
			});
		}
		
		if(!this.userObj.superuser && (toFetchOut || this.userObj.source == "bsj")){
			this.vehicleSvc.getVehicleOuts().subscribe((vhc) => {
				// redirect to map page if current route is login page
				if(this.currentRoute == ''){
					this.apiSvc.navigateInternal('map');
				}
				if(vhc.length > 0){
					let localSess:any = sessionStorage.getItem('user');
					let sessObj = JSON.parse(localSess);
					sessObj.source = "bsj";
					sessionStorage.setItem('user', JSON.stringify(sessObj));
				}
			},(err) => {
				console.log('err api')
			});
		}

		if(!this.userObj.superuser && (toFetchOut || this.userObj.source == "tracksolid")){
			let accounts = this.stateSvc.getTrackSolidAccounts();
			const requests = accounts.map(account =>
				this.vehicleSvc.getVehicleTracksolids(account.account)
			);

			let vehicleGroups:any = [];
			let objByhcl:any = {};
			let sessionVehicleIds = this.stateSvc.getUsersVehicleIds();
			forkJoin(requests).subscribe({
				next: (results:any) => {
					const allVehicles = results.flat();

					// update in state service, so any component can use the vehicel object
					this.stateSvc.setVehicles(allVehicles);
					sessionVehicleIds.forEach((uvhc:any) => {
						uvhc?.imeiNo?.forEach((vch) => {
							if (!vehicleGroups.includes(vch?.deviceGroup)) {
								vehicleGroups.push(vch?.deviceGroup);
							}
							objByhcl[vch?.imei] = vch;
						});
					});
					this.stateSvc.setVehicleGroups(vehicleGroups);
					this.stateSvc.setUsersVehicleObjIds(objByhcl);

					if(this.currentRoute == ''){
						this.apiSvc.navigateInternal('map');
					}
				},
				error: (error) => {
					console.error('Vehicle error:', error);
				}
			});
		}
	}
	
	ngOnDestroy(){
		clearInterval(this.pollInterval);
		this.pollInterval = false;
	}

	splitPlate(plate) {
		const regex = /^([A-Za-z]{1,3})(\d+)([A-Za-z]?)$/;
		const match = plate.match(regex);

		if (match) {
			var plateVis = {
				prefix: match[1],   // first letters
				number: match[2],   // numeric part
				suffix: match[3] || null // last letter (if any)
			};
			if(plateVis){
				if(!match[3]){
					return match[1] + ' ' + match[2];
				}else{
					return match[1] + ' ' + match[2] + ' ' + match[3];
				}
			}
		} else {
			return plate; // not a valid plate format
		}
	}


	searchVehicle(){
		this.isSubmitting = true;
		this.tryCounter = 0;
		let plateNo = this.vehiclePlate;
		this.requestByPlate(plateNo);
	}

	requestByPlate(plateNo){
		plateNo = plateNo.replace(/\u00A0/g, ' ').trim();
		return this.vehicleSvc.getVehicleByPlate(plateNo)
		.subscribe((res:any) => {
			if(res?.length > 0){
				let vfound:any = res[0];
				if(vfound?.username){
					let carOwn = vfound.username;
					let belongTrue = (this.supernames).includes(carOwn);
					if(belongTrue){
						this.tryCounter = 0;
						this.resultNull = false;
						this.resultFound = true;
						localStorage.setItem('jump_direct', JSON.stringify(vfound));
						setTimeout(()=>{
							this.loginWithId(vfound.username);
						}, 700);
						return;
					}else{
						this.resultNull = true;
						this.requestByPlateOut(plateNo);
					}
				}
			}else{
				var newPlate:any = "";
				if(plateNo.indexOf(' ') > -1){
					var splPlate = plateNo.split(' ');
					newPlate = splPlate.join('');
				}else{
					newPlate = this.splitPlate(plateNo);
				}
				this.tryCounter ++;
				if(this.tryCounter <= 3){
					this.requestByPlate(newPlate);
					if(plateNo.indexOf(' ') <= -1){
						this.requestByPlateOut(plateNo);
					}
				}else{
					this.requestByPlateOut(plateNo);
					// this.tryCounter = 0;
					// this.resultNull = true;
				}
			}
		})
	}

	requestByPlateOut(plateNo){
		this.authSvc.getCredentialData()
		.subscribe((str:any) => {
			let arrSubs:any = [];
			this.supernames.forEach((susr) => {
				arrSubs.push(susr.toLowerCase());
			});
			this.authSvc.getOutUserNames(str?.collection_keys?.master, str?.collection_keys?.base_url,arrSubs)
			.subscribe((users:any) => {
				if(users?.length > 0){
					users.forEach((usr) => {
						this.vehicleSvc.getUsersVehicles(usr.id)
						.subscribe((vhcs) => {
							if(vhcs.length > 0){
								vhcs.forEach((vhc) => {
									let newPlate = plateNo;
									let newPlateSpace = this.splitPlate(plateNo);
									let newPlate3 = plateNo;
									if(plateNo.indexOf(' ') > -1){
										var splPlate = plateNo.split(' ');
										newPlate3 = splPlate.join('');
									}
									
									let foundVhc = false;
									if(newPlate.toLowerCase() == (vhc.plate).toLowerCase()){
										foundVhc = true;
									}else if(!foundVhc && newPlateSpace.toLowerCase() == (vhc.plate).toLowerCase()){
										foundVhc = true;
									}else if(!foundVhc && newPlate3.toLowerCase() == (vhc.plate).toLowerCase()){
										foundVhc = true;
									}

									if(foundVhc){
										this.tryCounter = 0;
										this.resultNull = false;
										this.resultFound = true;
										localStorage.setItem('jump_direct', JSON.stringify(vhc));
										setTimeout(()=>{
											this.loginWithId(usr.name);
										}, 700);
									}
								})
							}
						})
					});
				}
				if(!this.resultFound){
					var newPlate:any = "";
					if(plateNo.indexOf(' ') > -1){
						var splPlate = plateNo.split(' ');
						newPlate = splPlate.join('');
					}else{
						newPlate = this.splitPlate(plateNo);
					}
					this.tryCounter ++;
					if(this.tryCounter <= 6){
						this.requestByPlateOut(newPlate);
						if(plateNo.indexOf(' ') <= -1){
							this.requestByPlateOutTrack(plateNo);
						}
					}else{
						this.requestByPlateOutTrack(plateNo);
						// this.tryCounter = 0;
						// this.resultNull = true;
					}
				}
			},
			(err) => {
				console.log('err',err)
			});
		})
		// this.vehicleSvc.getUsersVehicles()
		// .subscribe((user:any) => {

		// });
	}

	requestByPlateOutTrack(plateNo){
		this.authSvc.getAccessTokenTrack()
		.subscribe((result) => {
			if(result?.code == 0){
				let tokenInfo:any = result?.result;
				tokenInfo.token = result?.result?.accessToken;
				tokenInfo.token_expiry = this.authSvc.generateExpiryTracksoliToken(result?.result);
				localStorage.setItem('tracksolidtoken', JSON.stringify(tokenInfo));

				let arrSubs:any = [];
				this.supernames.forEach((susr) => {
					arrSubs.push(susr.toLowerCase());
				});
				this.authSvc.getOutTrackUserNames(arrSubs)
				.subscribe((users:any) => {
					if(users?.length > 0){
						users.forEach((usr) => {
							this.vehicleSvc.getUsersTracksolidVehicles(usr.account)
							.subscribe((vhcs) => {
								if(vhcs.length > 0){
									vhcs.forEach((vhc) => {
										let newPlate = plateNo;
										let newPlateSpace = this.splitPlate(plateNo);
										let newPlate3 = plateNo;
										if(plateNo.indexOf(' ') > -1){
											var splPlate = plateNo.split(' ');
											newPlate3 = splPlate.join('');
										}
										
										let foundVhc = false;
										if(newPlate.toLowerCase() == (vhc.deviceName).toLowerCase()){
											foundVhc = true;
										}else if(!foundVhc && newPlateSpace.toLowerCase() == (vhc.deviceName).toLowerCase()){
											foundVhc = true;
										}else if(!foundVhc && newPlate3.toLowerCase() == (vhc.deviceName).toLowerCase()){
											foundVhc = true;
										}

										if(foundVhc){
											this.tryCounter = 0;
											this.resultNull = false;
											this.resultFound = true;
											vhc.unitid = vhc.imei;
											localStorage.setItem('jump_direct', JSON.stringify(vhc));
											setTimeout(()=>{
												this.loginWithId(usr.account);
											}, 700);
										}
									})
								}
							})
						});
					}
					if(!this.resultFound){
						this.tryCounter = 99;
						this.resultNull = true;
						this.isSubmitting = false;
					}
				},
				(err) => {
					console.log('err',err);
					this.isSubmitting = false;
				});
			}
		})
		// this.vehicleSvc.getUsersVehicles()
		// .subscribe((user:any) => {

		// });
	}
}
